import { createMockCreator } from '@csp/test-common-utils';
import { OrgV1 } from '../generated/models/OrgV1';
import { OrgStatusType } from '../type/OrgStatusType';
import { OrgType } from '../type/OrgType';
import { countryV1Mock } from './CountryV1.mock';

export const orgV1Mock: OrgV1 = {
  orgId: '1',
  name: 'c1',
  eventId: 0,
  type: OrgType.COUNTRY,
  status: OrgStatusType.ACTIVE,
  country: countryV1Mock,
  branchParentIds: [],
  customStatuses: [],
  details: {
    contactPoints: [],
    contacts: [],
  },
  metas: [],
  parentId: 'parent id',
  test: true,
};

export const createOrgV1Mock = createMockCreator(orgV1Mock);
